export default "__VITE_ASSET__f4edc0ed__"